// extracted by mini-css-extract-plugin
export var cbContainer = "CustomerContentBlock-module--cb-container--17rq8";
export var mainImage = "CustomerContentBlock-module--main-image--2asbX";
export var square = "CustomerContentBlock-module--square--2Gp1T";
export var generalContainer = "CustomerContentBlock-module--general-container--1eySV";
export var blockquote = "CustomerContentBlock-module--blockquote--36qRa";
export var logo = "CustomerContentBlock-module--logo--39tl8";
export var logoSvg = "CustomerContentBlock-module--logo-svg--2uMMi";
export var quoteImg = "CustomerContentBlock-module--quote-img--2P09K";
export var playerWrapper = "CustomerContentBlock-module--player-wrapper--313BP";
export var reactPlayers = "CustomerContentBlock-module--react-players--ibVlB";
export var imgRight = "CustomerContentBlock-module--img-right--gvVs5";
export var CustomerContentBlockModuleGeneralContainer1eySV = "CustomerContentBlock-module--CustomerContentBlock-module--general-container--1eySV--q4lnm";